import createIcon from '../../createIcon';

/**
 * @component @name PlusOne
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNSA4LjVIOC41VjEyLjVINC41VjE0LjVIOC41VjE4LjVIMTAuNVYxNC41SDE0LjVWMTIuNUgxMC41VjguNVpNMTUgNi41OFY4LjRMMTcuNSA3LjlWMTguNUgxOS41VjUuNUwxNSA2LjU4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlusOne = createIcon('PlusOne', [
  [
    'path',
    {
      d: 'M10.5 8.5H8.5V12.5H4.5V14.5H8.5V18.5H10.5V14.5H14.5V12.5H10.5V8.5ZM15 6.58V8.4L17.5 7.9V18.5H19.5V5.5L15 6.58Z',
      key: 'kgf08j',
    },
  ],
]);

export default PlusOne;
